import React, { useState, useEffect, useRef } from "react";
import { inject, observer } from "mobx-react"; // eslint-disable-line
import { Therm, Donors, TeamTherm, DonorsDelay } from "../ui";
import { ErrorMessage, Spinner, Logo, LogoSmall } from "../elements";

import BeamRing1 from "../../images/GT/beam_ring1.png";
import BeamRing2 from "../../images/GT/beam_ring2.png";
import Super from "../../images/GT/super3.png";

const FullOverlay = (props) => {

  const [state, setState] = useState({
    activeWidth: 0,
    activeID: 0,
    activeName: '',
    activeAmount: 0,
    activeClass: '',
    activeExpand: 135,
    shine: '',
    prevRaised: 0,
    beam: 'off',
    activeMilestone: undefined,
    completeMilestones: [],
    nextMilestones: []
  })

  const myRef = useRef(null);
  const start = useRef(0);
  const end = useRef(0);
  const beamInt = useRef(0);

  useEffect(() => {
    /* Remove for production */
    const url = `${process.env.REACT_APP_LOCAL_URI}/gt-overlay/`;
    /* Remove for production */

    let streamer = window.location.href.replace(url, "").split("/");
    if (streamer[0][0] === "@" || streamer[0][0] === "+") {
      streamer[2] = streamer[0][0];
      streamer[0] = streamer[0].substr(1, streamer[0].length);
    } else {
      streamer[2] = "@";
    }

    /* Remove for production */
    if (streamer[0] !== '') {
      let streamType = streamer[2],
        username = streamer[0],
        slug = streamer[1]

      /* Remove for production */
      props.overlayStore.socketConnect(streamType, username, slug);

      return () => props.overlayStore.socketDisconnect();

    }

    start.current = setInterval(setActive, 600000);

    return () => {

      clearInterval(start.current)
      clearTimeout(end.current)
      clearTimeout(beamInt.current)
    }
  }, [])

  useEffect(() => {

    const { raised } = props.overlayStore;
    console.log("raised = " + raised);

    if ((raised - state.prevRaised) >= 5000) {
      setState((prev) => {
        return {
          ...prev,
          beam: 'on'
        }
      })

      beamInt.current = setTimeout(() => {
        setState((prev) => {
          return {
            ...prev,
            beam: 'off'
          }
        })
      }, 7000)
    }

    setState((prev) => {
      return {
        ...prev,
        prevRaised: raised
      }
    })
  }, [props.overlayStore.raised])

  useEffect(() => {

    const { milestones, goal, raised, percent } = props.overlayStore;

    const milestonesArray = milestones.map(milestone => {
      const miltotal = Math.round(parseFloat(milestone.amount) - raised)
      const thermtotal = Math.round(100 * (parseFloat(milestone.amount) / parseFloat(goal)))
      return {
        key: milestone.id,
        name: milestone.name,
        amount: formatNumber(milestone.amount),
        active: milestone.amount > raised ? true : false,
        therm: thermtotal > percent ? true : false,
        thermWidth: Math.round(100 - (100 * (miltotal / milestone.amount))),
      }
    })

    const milestonesComplete = milestonesArray.filter(next => !next.active);
    const milestonesNext = milestonesArray.filter(next => next.active);
    const milestonesActive = milestonesNext.shift();

    setState((prev) => {
      return {
        ...prev,
        activeMilestone: milestonesActive,
        completeMilestones: milestonesComplete,
        nextMilestones: milestonesNext
      }
    })

  }, [props.overlayStore.milestones, props.overlayStore.goal, props.overlayStore.raised, props.overlayStore.percent])

  const formatNumber = num => {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  };

  const endFunc = () => {
    setState((prev) => {
      return {
        ...prev,
        activeClass: ' no-show',
        activeExpand: 135
      }
    })
  }

  const setActive = () => {

    setState((prev) => {
      return {
        ...prev,
        activeClass: ' show',
        activeExpand: myRef.current.offsetWidth
      }
    })

    end.current = setTimeout(endFunc, 10000);
  }

  const { error, isLoading, cause, status, streamType, raised } = props.overlayStore;
  //const { accessToken } = props.userStore;

  const queryString = window.location.search;

  const urlParams = new URLSearchParams(queryString);
  const scrollerShow = urlParams.get('scroller');
  const scrollerPosition = urlParams.get('scrollerPosition');


  return error ? (
    <ErrorMessage>THERE HAS BEEN AN ERROR.</ErrorMessage>
  ) : isLoading ? (
    <Spinner />
  ) : (
    <div>
      {
        cause != '35' ?
          <p className="unpublished">This campaign is unpublished, retired or not a valid St. Jude campaign.</p>
          :
          status == 'published' ?
            <div className="max-overlay gt">
              {raised >= 100000 ?
                <div className="max-overlay__dollar-callout">
                  <span className="callout-circle"></span>
                  <p>$100,000</p>
                </div>
                : ''}
              {raised >= 200000 ?
                <div className="max-overlay__dollar-callout">
                  <span className="callout-circle"></span>
                  <p>$200,000</p>
                </div>
                : ''}
              {raised >= 300000 ?
                <div className="max-overlay__dollar-callout">
                  <span className="callout-circle"></span>
                  <p>$300,000</p>
                </div>
                : ''}
              {raised >= 400000 ?
                <div className="max-overlay__dollar-callout">
                  <span className="callout-circle"></span>
                  <p>$400,000</p>
                </div>
                : ''}
              {raised >= 500000 ?
                <div className="max-overlay__dollar-callout">
                  <span className="callout-circle"></span>
                  <p>$500,000</p>
                </div>
                : ''}
              {raised >= 600000 ?
                <div className="max-overlay__dollar-callout">
                  <span className="callout-circle"></span>
                  <p>$600,000</p>
                </div>
                : ''}
              {raised >= 700000 ?
                <div className="max-overlay__dollar-callout">
                  <span className="callout-circle"></span>
                  <p>$700,000</p>
                </div>
                : ''}
              {raised >= 800000 ?
                <div className="max-overlay__dollar-callout">
                  <span className="callout-circle"></span>
                  <p>$800,000</p>
                </div>
                : ''}
              {raised >= 900000 ?
                <div className="max-overlay__dollar-callout">
                  <span className="callout-circle"></span>
                  <p>$900,000</p>
                </div>
                : ''}
              {raised >= 1000000 ?
                <div className="max-overlay__dollar-callout">
                  <span className="callout-circle"></span>
                  <p>$1,000,000</p>
                </div>
                : ''}
              <div className="max-overlay__milestone-meter">

                {state.completeMilestones.map(milestones => (
                  <div
                    key={milestones.key}
                    className="completed left"
                  >
                  </div>
                ))}
                {state.activeMilestone !== undefined ?
                  <div
                    key={state.activeMilestone.key}
                    className={'left active' + state.activeClass}
                    style={{
                      width: `
                        ${myRef.current && state.activeClass == ' show' ? myRef.current.offsetWidth : 135}px
                      `
                    }}
                  >
                    <div
                      className="therm"
                      style={{
                        width: `
                            ${state.activeMilestone.thermWidth}%
                          `
                      }}>
                      <span ref={myRef}>{state.activeMilestone.name} - ${state.activeMilestone.amount}</span>
                    </div>

                  </div>
                  :
                  <div ref={myRef}></div>
                }

                {state.nextMilestones.map(milestones => (
                  <div
                    key={milestones.key}
                    className="upnext left"
                  >
                  </div>
                ))}

              </div>
              <div className={scrollerShow === 'yes' ? 'max-overlay__left' : 'max-overlay__left small'}>
                {scrollerShow === 'yes' ?
                  <Logo />
                  :
                  <LogoSmall />
                }
              </div>

              <div className={'max-overlay__right' + state.shine} style={{
                height: `${scrollerShow === 'yes' ? '' : '60px'}`
              }}>
                {scrollerShow === 'yes' && scrollerPosition === 'top' ?
                  <Donors />
                  : ''}
                <div className={'big_therm cf ' + state.beam}>
                  {/* <div class="big_therm cf"> */}
                  <div className="big_therm__expanding-bar left" />
                  <div className="big_therm__front left" />
                  <div className="super">
                    <img src={Super} />
                    <div className="big_therm__line1" />
                    <div className="big_therm__line2" />
                    <div className="big_therm__line3" />
                    <div className="big_therm__line4" />
                    <div className="big_therm__line5" />
                    <div className="big_therm__line6" />
                  </div>
                  <img className="big_therm__ring1" src={BeamRing1} />
                  <img className="big_therm__ring2" src={BeamRing2} />
                </div>
                {streamType === '@' ?
                  <Therm />
                  : streamType === '+' ?
                    <TeamTherm />
                    : ''}
                {scrollerShow === 'yes' && scrollerPosition === 'bottom' ?
                  <DonorsDelay />
                  : ''}
              </div>

            </div>
            :
            <p className="unpublished">This campaign is unpublished, retired or not a valid St. Jude campaign.</p>
      }
    </div>
  );
}

export default inject("overlayStore")(observer(FullOverlay));
